<div class="d-flex" style="border-bottom: 1px solid #00ffff; justify-content: space-between;">
  <label style="width: 50%;" for="address">{{labelName}} *</label>
  <div *ngIf="numberOfGuests == 0" class="alert alert-danger">
    <div class="d-flex flex-row alert-danger-content">
        <div class="alert-danger-info" matTooltipClass="tooltip-danger" matTooltip="{{'INFO.GREATER_THAN_ERROR' | translate}}">
          <div>?</div>
        </div>
    </div>
  </div>
</div>

<div class="capacity-container d-flex flex-row">
  <div class="d-flex flex-row">
    <button (click)="addSubCapacity(-1)">
      <span>-</span>
      <span>1</span>
    </button>
    <button (click)="addSubCapacity(-10)">
      <span>-</span>
      <span>10</span>
    </button>
    <button (click)="addSubCapacity(-100)">
      <span>-</span>
      <span>100</span>
    </button>
  </div>
  <div class="d-flex flex-row ps-2">
    <mat-icon class="profile">person</mat-icon>
    <input (change)="onCapacityChange()" disabled="true" type="number" min="1" max="{{maximumCapacity}}" [(ngModel)]="numberOfGuests" id="numberOfGuests" name="numberOfGuests" placeholder='0'>
  </div>
  <div class="d-flex flex-row">
    <button (click)="addSubCapacity(1)">
      <span>+</span>
      <span>1</span>
    </button>
    <button (click)="addSubCapacity(10)">
      <span>+</span>
      <span>10</span>
    </button>
    <button (click)="addSubCapacity(100)">
      <span>+</span>
      <span>100</span>
    </button>
  </div>
</div>
